export default "__VITE_ASSET__ClrzT8K8__"